module.exports = __webpack_public_path__ + "img/phone.b6acc997.png";